<template>
	<main class="school-mgn-list" style="background: #f5f5fb;">
		<div
			class="mainList"
			v-if="
				$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value ||
        $store.state.user.userInfo.type === $api.account.types.RESEARCH.value
			"
		>
			<el-form label-width="80px" :inline="true" @submit.native.prevent style="margin-left: 13px;padding: 5px 0">
				<el-form-item>
          <InputTopTip v-model="filter_form.name" placeholder="谱例名称">
            <el-input
              style="width: 220px;"
              @keyup.native.enter="currentPage = 1, refreshDataList()"
              v-model="filter_form.name"
              size="small"
              placeholder=""
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item v-if="$store.state.user.userInfo.type !== $api.account.types.RESEARCH.value">
          <InputTopTip v-model="filter_form.username" placeholder="创建人">
            <el-input
              style="width: 220px;"
              placeholder=""
              @keyup.native.enter="currentPage = 1, refreshDataList()"
              v-model="filter_form.username"
              size="small"
            >
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </InputTopTip>
				</el-form-item>
				<el-form-item v-if="$store.state.user.userInfo.type !== $api.account.types.RESEARCH.value">
          <InputTopTip v-model="filter_form.fb_music_type" placeholder="曲谱类型">
            <el-select
              placeholder=""
              v-model="filter_form.fb_music_type"
              size="small"
              class="width-166"
              @change="e => { currentPage = 1, refreshDataList() }"
            >
              <el-option v-for="item in musical" :key="item.val" :label="item.name" :value="item.val"></el-option>
            </el-select>
          </InputTopTip>
				</el-form-item>
			</el-form>

			<div style="display: flex; margin-left: auto;">
				<template>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="margin-right: 15px; width: 70px;"
						@click="currentPage = 1, refreshDataList()"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="
							background: #f7f8fa;
							border: 1px solid #dcdcdc;
							color: #4b4b4b !important;
							margin-right: 12px;
							width: 70px;
						"
						@click="clearList"
						>重置</el-button
					>
				</template>
			</div>
		</div>

		<div style="background: #ffffff;" v-else>
			<div class="tabs">
				<div
					@click="handleClick(item.id)"
					v-for="item in tabs"
					:key="item.id"
					:class="['tabs-pane', activeId === item.id && 'tabs-pane-avtive']"
					:_disabled="false"
				>
					{{ item.name }}
				</div>
			</div>
			<el-form :inline="true" class="form" ref="form" :model="form">
				<div class="form-contain">
					<el-form-item>
            <InputTopTip v-model="filter_form.name" placeholder="请输入谱例名称">
              <el-input
                style="width: 220px;"
                placeholder=""
                @keyup.native.enter="currentPage = 1, refreshDataList()"
                v-model="filter_form.name"
                size="small"
              >
              </el-input>
            </InputTopTip>
					</el-form-item>
          <el-form-item v-if="activeId === 0">
            <InputTopTip v-model="filter_form.username" placeholder="创建人">
              <el-input
                style="width: 220px;"
                placeholder=""
                @keyup.native.enter="currentPage = 1, refreshDataList()"
                v-model="filter_form.username"
                size="small"
              >
              </el-input>
            </InputTopTip>
          </el-form-item>
          <el-form-item v-if="$store.state.user.userInfo.type !== $api.account.types.RESEARCH.value">
            <InputTopTip v-model="filter_form.fb_music_type" placeholder="曲谱类型">
              <el-select
                v-model="filter_form.fb_music_type"
                size="small"
                placeholder=""
                class="width-166"
                @change="e => { currentPage = 1, refreshDataList() }"
              >
                <el-option v-for="item in musical" :key="item.val" :label="item.name" :value="item.val"></el-option>
              </el-select>
            </InputTopTip>
          </el-form-item>
				</div>

				<el-form-item class="form-reset">
					<el-button type="primary" @click="currentPage = 1, refreshDataList()" size="small" style="width: 70px; margin-right: 15px;"
						>搜索</el-button
					>
					<el-button
						type="primary"
						class="action-btn"
						size="small"
						style="background: #f7f8fa; border: 1px solid #dcdcdc; color: #4b4b4b !important; width: 70px;"
						@click="clearList"
						>重置</el-button
					>
				</el-form-item>
			</el-form>
		</div>

		<section class="list-area" style="margin-top: 8px;">
			<div
				class="list-area-otis"
			>
				<template>
					<div style="display: flex; padding-left: 18px;" >
						<el-button
							type="primary"
							size="small"
							icon="el-icon-plus"
							style="margin-right: 15px;"
							@click="NewScore"
              v-if="
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId === 1)||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId === 1 && $permissions(['SP60001'])) ||
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId === 5)
              "
							>新建</el-button
						>
					</div>
					<div v-if="
            ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId === 1)||
            ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId === 1 && $permissions(['SP60002'])) ||
            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId === 5)
          ">
						<el-button
							type="primary"
							size="small"
							icon="el-icon-delete"
							:class="multipleSelection.length === 0 ? 'box' : 'box2'"
							:disabled="multipleSelection.length === 0"
							@click="batchDelete()"
							v-if="multipleSelection.length > 0"
							>批量删除</el-button
						>
					</div>
				</template>
			</div>

			<el-table
				:data="tableData"
				ref="multipleTable"
				tooltip-effect="dark"
				@selection-change="handleSelectionChange"
				width="100%"
			>
				<el-table-column
					type="selection"
					width="60"
					align="center"
					v-if="
						($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId === 1) ||
						($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId === 1 && $permissions(['SP60003', 'SP60009', 'SP60007', 'SP60006', 'SP60008'])) ||
						($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId === 5) ||
            $store.state.user.userInfo.type === $api.account.types.RESEARCH.value
					"
          :key="'selection'"
				></el-table-column>
				<el-table-column :key="'name'" prop="name" label="谱例名称" width="250" align="left"></el-table-column>
				<el-table-column :key="'music_type'" prop="music_type" :formatter="music_typeFormat" label="曲目类型" align="left">
				</el-table-column>

				<el-table-column :key="'谱音同步状态'" align="left" label="谱音同步状态">
					<template slot-scope="scope">
						<div style="display: flex; justify-content: left; align-items: center;">
							<span slot="reference" v-show="scope.row.is_score_sync === 1" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #67c23a;"></i>
							</span>
							<span slot="reference" v-show="scope.row.is_score_sync === 0" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #b81a19;"></i>
							</span>
							{{ scope.row.is_score_sync === 0 ? '未同步' : '已同步' }}
						</div>
					</template>
				</el-table-column>

				<el-table-column :key="'跟唱同步状态'" align="left" label="跟唱同步状态">
					<!-- 产品反水~一会展示一会不展示，先注释代码 -->
					<!-- v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
						$store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value
					" -->
					<template slot-scope="scope">
						<div style="display: flex; justify-content: left; align-items: center;">
							<span slot="reference" v-show="scope.row.sync_id != 0" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #67c23a;"></i>
							</span>
							<span slot="reference" v-show="scope.row.sync_id === 0" style="margin-right: 5px;">
								<i class="dotClass" style="background-color: #b81a19;"></i>
							</span>
							{{ scope.row.sync_id === 0 ? '未同步' : '已同步' }}
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="account.realname"
					label="创建人"
					align="left"
          :key="'realname'"
					v-if="
						$store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value ||
						$store.state.user.userInfo.type === $api.account.types.OTHER.value ||
            $store.state.user.userInfo.type === $api.account.types.SCHOOL_ADMIN.value ||
            ($store.state.user.userInfo.type === $api.account.types.TEACHER.value)
					"
				>
				</el-table-column>
				<el-table-column :key="'is_public'" align="left" label="查看权限" prop="is_public" class-name="opscol">
					<template v-slot="{ row }">
						{{ limits[row.is_public] }}
					</template>
				</el-table-column>
				<el-table-column :key="'set'" align="center" label="操作" class-name="opscol" width="250px">
					<template v-slot:default="slot">
						<div class="table-mgn4">
              <el-tooltip content="谱音" placement="bottom" effect="light" v-if="
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId == 5) ||
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId == 1) ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId == 1 && $permissions([SP60003]))
              ">
                <div
                  style="color: #ffb800;"
                  @click="SetScoreSync(slot.row.id)"
                  id="searchAddress"
                >
                  <svg
                    class="icon"
                    aria-hidden="true"
                    style="width: 19px; height: 19px; outline: none; box-shadow: none;"
                  >
                    <use xlink:href="#icon-gansing"></use>
                  </svg>
                </div>
              </el-tooltip>
              <el-tooltip content="谱例" placement="bottom" effect="light" v-if="
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId == 5) ||
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId == 1) ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId == 1 && $permissions(['SP60009']))
              ">
                <div
                  style="color: #3f6af7;"
                  @click="ReviseScore(slot.row.id)"
                  class="btn"
                >
                  <svg
                    class="icon"
                    aria-hidden="true"
                    style="width: 28px; height: 28px; outline: none; box-shadow: none;"
                  >
                    <use xlink:href="#icon-sample"></use>
                  </svg>
                </div>
              </el-tooltip>

              <!-- v-permission="SP60004" -->
              <el-tooltip content="跟唱同步" placement="bottom" effect="light" v-if="
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId == 5) ||
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId == 1) ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId == 1 && $permissions(['SP60007']))
              ">
                <div
                  style="color: #3f6af7;"
                  @click="openSingSynchro(slot)"
                  class="btn"
                >
                  <img _w="28px" :src="require('@/assets/image/synchroel.png')" />
                </div>
              </el-tooltip>
              <el-tooltip content="查看" placement="bottom" effect="light" v-permission="SP60005">
                <div @click="chelook(slot.row.id)" >
                  <i aria-hidden="true" class="icon el-icon-view" style="color: rgb(255, 113, 67);"></i>
                </div>
              </el-tooltip>

              <!-- 设计的什么垃圾玩意 -->
              <!-- ($store.state.user.userInfo.type === $api.account.types.OTHER.value && $permissions([SP60006]) && slot.row.is_owner) || -->

              <el-tooltip content="删除" placement="bottom" effect="light" v-if="
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId == 5) ||
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId == 1) ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId == 1 && $permissions([SP60006]))
              ">
                <div
                  class="icon delete"
                  @click="promptRemove(slot.row.id)"
                >
                  <svg
                    class="icon"
                    aria-hidden="true"
                    style="width: 100%; height: 100%; outline: none; box-shadow: none;"
                  >
                    <use xlink:href="#icon-deltred"></use>
                  </svg>
                </div>
              </el-tooltip>
              <el-tooltip content="权限" placement="bottom" effect="light" v-if="
                ($store.state.user.userInfo.type === $api.account.types.TEACHER.value && activeId == 5) ||
                ($store.state.user.userInfo.type === $api.account.types.PLATFORM_ADMIN.value && activeId == 1) ||
                ($store.state.user.userInfo.type === $api.account.types.OTHER.value && activeId == 1 && $permissions(['SP60008']))
              ">
                <div
                  @click=";(limitsVisible = true), (limitsRow = { id: slot.row.id, is_public: slot.row.is_public })"
                >
                  <img style="width: 100%; height: 100%;" :src="require('@/assets/icons/svg/power.png')" />
                </div>
              </el-tooltip>
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination-page">
				<span class="pagetotal">总计：{{ totalItems }}条/{{ Math.ceil(totalItems / pageSize) }}页</span>
				<el-pagination
					class="pagination"
					background
					@size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:page-size="pageSize"
					:total="totalItems"
					:current-page.sync="currentPage"
					:page-sizes="[10, 20, 50, 100]"
					layout="prev,pager,next,jumper,sizes"
					style="margin-top: 21px; margin-left: 10px;"
          :key="`${paginationKey}_${activeId}`"
				>
				</el-pagination>
			</div>
			<SingSynchro ref="singSynchro" @scoreSync="SetScoreSync" @success="() => { currentPage = 1, refreshDataList() }" />
		</section>

		<el-dialog
			class="scope-dialog"
			:width="'540px'"
			:before-close="
				() => {
					;(limitsVisible = false), (limitsRow = {})
				}
			"
			:close-on-click-modal="false"
			:visible="limitsVisible"
			@close="
				() => {
					;(limitsVisible = false), (limitsRow = {})
				}
			"
			title="权限"
		>
			<el-divider></el-divider>
			<div _m="y-20px">
				<span _m="r-15px">查看权限</span>
				<el-radio-group v-model="limitsRow.is_public" size="medium">
					<el-radio-button :label="0" :value="0" :key="0">私有谱例</el-radio-button>
					<el-radio-button :label="1" :value="1" :key="1">公开谱例</el-radio-button>
				</el-radio-group>
			</div>
			<div _text="[#9B9B9B]" _m="t-20px b-30px">
				非私有可用谱例范围，其他符合条件范围的学生、教师都可以使用于测试和练习
			</div>
			<el-divider></el-divider>
			<div style="margin-top: 20px; margin-bottom: 20px; display: flex; align-items: center; justify-content: center;">
				<el-button class="btn-close" @click="limitsVisible = false" style="width: 80px; height: 32px; line-height: 1px;"
					>取 消</el-button
				>
				<el-button
					class="btn-prim"
					type="primary"
					@click="updateState"
					style="width: 80px; height: 32px; line-height: 1px;"
					>确定</el-button
				>
			</div>
		</el-dialog>
	</main>
</template>
<script>
import { SP60001, SP60002, SP60003, SP60004, SP60005, SP60006 } from '@/utils/permissionMap.js'
import SingSynchro from './SingSynchro.vue'
const ErrorImg = require('@/assets/test_client/reviewing@2x.png')
const ErrorImzxc = require('@/assets/test_client/sucess_icon@2x.png')
const puin = require('@/assets/test_client/puin.png')
const gansing = require('@/assets/test_client/gansin.png')
import { limits, musical, adminIdentity, teacherIdentity, schoolIdentity } from './const.js'

export default {
	components: { SingSynchro },
	data() {
		return {
      adminIdentity, teacherIdentity, schoolIdentity,
			SP60001,
			SP60002,
			SP60003,
			SP60004,
			SP60005,
			SP60006,
			ErrorImg,
			ErrorImzxc,
			puin,
			gansing,
			tableData: [], // 用户列表
			//baseinfo: {}, // 曲谱信息
			currentPage: 1, // 第几页
			totalItems: 0, //总数
			pageSize: 10, // 每页的条数据
			multipleSelection: [], // 批量删除
			filter_form: {
				name: '',
        username: ''
			}, //搜索名字
			currentPracticeSheetObj: null,
			CheckScore: false,
			// tabs: [
			// 	{
			// 		name: '自有',
			// 		id: 1
			// 	},
			// 	{
			// 		name: '平台',
			// 		id: 0
			// 	},
			// ],
      tabs: [],
			activeId: 2, // 2是代表能插入自己平台导入的所有曲谱
			limits,
			musical,
			limitsRow: {},
			limitsVisible: false,
			tableKey: 0, //切换组件时改变key值
			form: {
				title: ''
			},
      paginationKey: new Date().getTime()
		}
	},
	watch: {},
	created() {
    try {
      const userInfo = this.$store.state.user.userInfo
      if (userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
				this.tabs = this.schoolIdentity
			} else if (userInfo.type === this.$api.account.types.TEACHER.value) {
				this.tabs = this.teacherIdentity
			} else if (userInfo.type === this.$api.account.types.PLATFORM_ADMIN.value) {
				this.tabs = this.adminIdentity
			} else if (userInfo.type === this.$api.account.types.RESEARCH.value) {
        this.tabs = this.researchIdentity
      } else {
				this.tabs = this.adminIdentity
			}
      this.getSearchParams()
      this.refreshDataList()
    } catch(err) {
      console.log('正常~')
      this.refreshDataList()
    }
	},
	methods: {
		// 打开跟唱同步
	openSingSynchro(slot) {
		// console.log('slot', slot)
		// this.$refs.singSynchro.openDialog(slot.row)
		let accesstoken = this.GetToken()
		let url = `${window.web_config.api_url}/assets/sing-along-sync/#/editor?bind_music_id=${slot.row.id}&token=${accesstoken}`
		if (slot.row.sync_id != 0) {
			url += `&id=${slot.row.sync_id}`
		}
		window.open(url)
	},
    getSearchParams(top = undefined) {
      const searchParams = this.$store.state.searchParams[this.$route.name]
      if (top != undefined) {
        this.activeId = top
        this.currentPage = searchParams[top]?.page || 1
        this.pageSize = searchParams[top]?.page_size || 10
        this.filter_form.name = searchParams[top]?.fu_name
        this.filter_form.username = searchParams[top]?.username
        this.filter_form.fb_music_type = searchParams[top]?.fb_music_type
      } else {
        try {
          const { historyTop } = searchParams
          this.activeId = historyTop
          this.currentPage = searchParams[historyTop]?.page
          this.pageSize = searchParams[historyTop]?.page_size
          this.filter_form.name = searchParams[historyTop]?.fu_name
          this.filter_form.username = searchParams[historyTop]?.username
          this.filter_form.fb_music_type = searchParams[historyTop]?.fb_music_type
        } catch(err) {
          console.log('正常~')
          this.activeId = this.tabs[0]?.id
        }
      }
      this.paginationKey = new Date().getTime()
    },
		async updateState() {
			await this.$api2.bureau.updateState(this.limitsRow.id, this.limitsRow)
			this.limitsVisible = false
			this.refreshDataList()
		},
		async handleClick(e) {
			if (this.activeId != e) {
				// this.activeId = e
				this.tableKey = e
        // this.currentPage = 1
        this.getSearchParams(e)
				this.refreshDataList()
			}
		},
		practiceSheetNewEditDialogClose() {
			this.currentPracticeSheetObj = null
		},
		music_typeFormat(row, column) {
			if (row.music_type === 'easy') {
				return '简谱'
			} else if (row.music_type === 'big') {
				return '大谱表'
			} else if (row.music_type === 'treble') {
				return '高音'
			} else if (row.music_type === 'bass') {
				return '低音'
			} else if (row.music_type === 'four') {
				return '合唱四声部'
			} else {
				return 'Null'
			}
		},
		//查看谱例
		chelook(rowid) {
			// this.$router.push({
			// 	name: 'exampleManageEdit',
			// 	params: { id: rowid, ptid: this.activeId }
			// })
      this.$router.push({
				name: 'exampleManageLook',
				params: { id: rowid }
			})
		},
		//获取Token
		GetToken() {
			let loadConfigStr = localStorage.getItem('tokenInfo')
			let loadConfig = null
			if (loadConfigStr) {
				loadConfig = JSON.parse(loadConfigStr)
			}
			return loadConfig.access_token
		},
		//设置谱音同步
		SetScoreSync(scoreid) {
			let accesstoken = this.GetToken()
			window.open(`${window.web_config.api_url}${window.web_config.music_score_audio_path}?id=${scoreid}&token=${accesstoken}`)
		},
		//修改曲谱
		ReviseScore(scoreid) {
			let accesstoken = this.GetToken()
			window.open(`${window.web_config.api_url}${window.web_config.music_score_editor_path}?id=${scoreid}&token=${accesstoken}`)
			//document.getElementById("searchAddress").click();
			//this.$refs.searchAddress.$el.click()
		},
		//新建曲谱
		NewScore() {
			let accesstoken = this.GetToken()
			window.open(`${window.web_config.api_url}${window.web_config.music_score_editor_path}?token=${accesstoken}`)
		},
		clearList() {
			this.filter_form.name = ''
			this.filter_form.username = ''
			this.filter_form.fb_music_type = ''
			this.refreshDataList()
		},
		//获取列表数据
		async refreshDataList() {
			// if (this.$store.state.user.userInfo.type === this.$api.account.types.SCHOOL_ADMIN.value) {
			// 	this.activeId = 0
			// }
      const params = {
				page: this.currentPage,
				page_size: this.pageSize,
				fu_name: this.filter_form.name,
				// is_private: this.activeId,
        scope_type: this.activeId,
				username: this.filter_form.username,
				fb_music_type: this.filter_form.fb_music_type,
        is_all: ''
			}
      this.$store.commit('setTabSearchParams', { key: this.$route.name, top: this.activeId, params: params })
			let res = null
			res = await this.$api.bureau.ScoreList(params)
			this.totalItems = res.meta.total
			this.tableData = res.data
		},
		practiceSheetSaveEnd() {
			this.CheckScore = false
		},
		//查看
		/* 	async CheckCheck(scoreid) {
			let res = null
			res = await this.$api.bureau.GetBaseInfo(scoreid)
			this.baseinfo = res
			this.CheckScore = true

		}, */
		//每页下拉只显示的数据
		handleSizeChange(val) {
			this.currentPage = 1
			this.pageSize = val
			this.refreshDataList()
		},
		//当前点击的是第几页
		handleCurrentChange(currentPage) {
			this.currentPage = currentPage
			this.refreshDataList()
		},
		//批量删除数据
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		//批量删除
		batchDelete() {
			this.$confirm('此操作将永久删除该曲谱, 是否继续?', '温馨提示️️️', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(res => {
					let idse = this.multipleSelection.map(item => item.id)
					this.$api.bureau
						.ScoreDeletes({
							ids: idse
						})
						.then(cRes => {
							if (cRes.success === true) {
								this.refreshDataList()
								this.$message({
									message: '删除成功',
									type: 'success'
								})
							}
						})
				})
				.catch(() => {})
		},
		//单条删除
		promptRemove(id) {
			this.$confirm('是否删除该谱例?', '温馨提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(async () => {
					let res2 = null
					res2 = await this.$api.bureau.ScoreDelete(id)
					if (res2.success === true) {
						this.refreshDataList()
						this.$message({
							message: '删除成功',
							type: 'success'
						})
					}
				})
				.catch(() => {})
		}
	}
}
</script>
<style lang="scss" scoped>
.action-btn:focus {
	background-color: #ff5e2a;
	border-color: #ff5e2a;
	opacity: 1 !important;
}
.box {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box:hover {
	margin-right: 15px;
	background: #9f9f9f;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.box2 {
	margin-right: 15px;
	background: #f7f8fa;
	border: 2px solid #f7f8fa;
	color: #4b4b4b !important;
}
.tabs {
	display: flex;
	align-items: center;
	border-bottom: 1px solid #eeeeee;
	height: 39px;
}
.tabs-pane-avtive {
	color: #4a4a4a !important;
	position: relative;
}
.tabs-pane-avtive::after {
	content: '';
	display: block;
	position: absolute;
	top: 38px;
	width: 43px;
	height: 2px;
	background: #ff5e2a;
	border-radius: 0px 0px 0px 0px;
}
.tabs-pane {
	margin-left: 17px;
	margin-right: 8px;
	width: 36px;
	height: 39px;
	font-size: 18px;
	font-family: PingFang SC-Bold, PingFang SC;
	font-weight: bold;
	color: #bbbbbb;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
}

.form {
	padding: 8px 0px 10px 19px;
	display: flex;
	justify-content: space-between;
	min-height: 46px;
}
.form-contain {
	flex-basis: 80%;
}
.form-reset {
	display: flex;
	flex-wrap: nowrap;
  /deep/ .el-form-item__content {
    white-space: nowrap;
  }
}
.width-101 {
	width: 101px;
}
.width-166 {
	width: 166px;
}
.width-264 {
	width: 264px;
}

/deep/.el-table thead th {
	background-color: #fafafa;
	border-top: 1px solid #fff;
}
.pagetotal {
	width: 200px;
	margin-left: 20px;
	font-size: 14px;
	line-height: 70px;
	font-family: PingFang SC-Medium, PingFang SC;
	font-weight: 500;
	color: #010101;
	text-overflow: ellipsis;
	white-space: nowrap;
	overflow: hidden;
}
.pagination {
	width: 100%;
	margin-top: 20px;
	text-align: right;
}
.dotClass {
	width: 10px;
	height: 10px;
	border-radius: 50%;
	display: block;
}
.el-form-item {
	margin-bottom: 1px;
}
// 列表操作图标
.table-mgn4 {
	display: flex;
	justify-content: center;
	font-size: 16px;
	color: #999999;
	div {
		cursor: pointer;
		height: 28px;
		width: 28px;
		border: 1px solid #ebeef5;
		border-radius: 14px;
		margin-right: 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		&.delete {
			border: 1px solid #fdeaec;
		}
	}
}

.el-dialog {
	border-radius: 15px;
}
.dialog-title {
	font-size: 20px;
	color: #21a74a;
	display: flex;
	justify-content: space-between;
	.icon {
		font-size: 24px;
		margin-right: 4px;
	}
}
.pagination-page {
	height: 60px;
	display: flex;
	justify-content: left;
	align-items: left;
}
.exp-blue {
	margin-left: 10px;
	color: #21a74a !important; //rgb(255, 255, 255)
}
.del-red {
	color: rgb(227, 23, 13) !important;
}
.school-district-mgn-list {
	.el-table {
		min-height: 504px;
	}
	.action-btn-block {
		height: 60px;
		padding-top: 20px;

		.action-btn {
			float: right;
			margin-right: 20px;
		}
	}
	.opscol div.cell > a {
		margin-right: 0.5em;

		&:last-child {
			margin-right: 0;
		}
	}
}

.btn:focus {
	outline: none;
	box-shadow: none;
}

.scope-dialog {
	/deep/ .el-dialog .el-dialog__header {
		padding-bottom: 0px;
	}
	/deep/ .el-dialog__title {
		font-size: 16px;
	}
	.scope-file {
		display: flex;
		flex-wrap: wrap;
		width: 50px;
		img {
			width: 50px;
			object-fit: contain;
		}
	}
}
</style>

